import React, {Suspense} from 'react';
import LoadingContainer from "../../../../../Common/component/LoadingContainer/LoadingContainer";
import ErrPage from "../../../../../Common/pages/ErrPage";

/*
import DemodocumentMgr from '../../../../../Docuwiz-service/DEMO/admin/index/DocumentMgr';
import DocumentMgr from '../../../../../Docuwiz-service/POSTECH/admin/index/DocumentMgr';
import BpaDocumentMgr from '../../../../../Docuwiz-service/BUSANPA/admin/index/DocumentMgr';


 */
function DocumentMgrPage(){
    const serviceCode:string           =    process.env.REACT_APP_SERVICE_NAME as string;
    const ComponentAdminIndex = React.lazy(()=>import(`../../../../../Docuwiz-service/Customer/${serviceCode}/admin/index/DocumentMgr`))

    /*
    switch (serviceCode) {
        case 'DEMO':
            return (
                <DemodocumentMgr/>
            );
        case 'POSTECH':
            return (
                <DocumentMgr/>
            );
        case 'BUSANPA':
            return (
                <BpaDocumentMgr/>
            );
        default:
            return (
                <></>
            );
    }

     */

    return ComponentAdminIndex ?   <Suspense fallback={<LoadingContainer message="Loading Modules.." />}>
                                        <ComponentAdminIndex />
                                    </Suspense>
                                :     <ErrPage errCode={9999} />;
}

export default DocumentMgrPage;